
const BuildMetricsChoice = (metrics) => {

    const conditionsChoice = metrics.conditions.filter(condition => condition.name != null).map( condition => { return { value : condition.id + '-condition_id', text : condition.name == null ? condition.id : condition.name, index : condition.id} });
    const redirectionsChoice = metrics.redirections.filter(condition => condition.name != null).map(redirection => { return { value : redirection.id + '-redirection_id', text : redirection.name == null ? redirection.id : redirection.name ,index : redirection.id} });
    const categorizationsChoice = (metrics.categorizations || []).filter(categorization => categorization.name != null).map(categorization => { return { value : categorization.id + '-categorization_id', text : categorization.name == null ? categorization.id : categorization.name ,index : categorization.id} });

    const metricsChoice = [{value : null, text : 'All Metrics', index : null}, ...conditionsChoice, ...redirectionsChoice, ...categorizationsChoice];

    return metricsChoice;
}

export default BuildMetricsChoice;